<template>
  <div class="form-collapse">
    <div class="info">
      <layui-form ref="repairPartForm" :rule="form_rule" :requestUniqueId="requestId">
        <template slot-scope="{ scope }">
          <div class="layui-form">
            <template>
              <layui-collapse>
                <div class="layui-colla-item">
                  <h2 class="layui-colla-title">备件基本信息</h2>
                  <div class="layui-colla-content layui-show">
                    <div class="layui-form-item-one">
                      <div class="layui-form-item">
                        <label class="layui-form-label"><span class="x-red">*</span>备件类型：</label>
                        <div class="layui-input-inline">
                            <layui-select
                              :enabled="true"
                              table-name="DB_DICTIONARY"
                              text-field = "DIC_NAME"
                              value-field = "DIC_CODE"
                              :queryCondition="{'DIC_CATEGORY:0': '备件类型', 'DIC_PCODE:3': '-1' }"
                              :show-null-option = "true"
                              :enable-search="true"
                              @selectChange='multSelectChange($event)'
                              name="REPAIR_PART_TYPE"
                              v-model="config.form.REPAIR_PART_TYPE"
                            ></layui-select>
                        </div>
                      </div>
                      <div class="layui-form-item" >
                        <label class="layui-form-label"><span class="x-red">*</span>备件名称： </label>
                        <div class="layui-input-inline">
                          <input type="text" v-model="config.form.REPAIR_PART_NAME" autocomplete="off" class="layui-input"  name="REPAIR_PART_NAME"  placeholder="请输入备件名称" />
                        </div>
                      </div>
                      <div class="layui-form-item">
                        <label class="layui-form-label"><span class="x-red">*</span>型号： </label>
                        <div class="layui-input-inline">
                          <input type="text" v-model="config.form.REPAIR_PART_MODEL" autocomplete="off" class="layui-input"  name="REPAIR_PART_MODEL"  placeholder="请输入型号" />
                        </div>
                      </div>
                       <div class="layui-form-item">
                        <label class="layui-form-label"><span class="x-red">*</span>序列号： </label>
                        <div class="layui-input-inline">
                          <input type="text" v-model="config.form.REPAIR_PART_SERIAL" autocomplete="off" class="layui-input"  name="REPAIR_PART_SERIAL"  placeholder="请输入序列号" />
                        </div>
                      </div>
                      <!-- <div class="layui-form-item"  v-if="!showRepairType">
                        <label class="layui-form-label">备件类别：</label>
                        <div class="layui-input-inline">
                            <layui-select
                              :enabled="true"
                              table-name="DB_DICTIONARY"
                              text-field = "DIC_NAME"
                              value-field = "DIC_CODE"
                              :queryCondition="{'DIC_CATEGORY:0': '备件类别', 'DIC_PCODE:3': '-1' }"
                              :show-null-option = "true"
                              :enable-search="true"
                              name="REPAIR_PART_CATEGORY"
                              v-model="config.form.REPAIR_PART_CATEGORY"
                            ></layui-select>
                        </div>
                      </div> -->
                      <div class="layui-form-item"  v-if="!showRepairType">
                        <label class="layui-form-label">回收备件：</label>
                        <div class="layui-input-inline">
                            <layui-select
                              :enabled="true"
                              table-name="DB_DICTIONARY"
                              text-field = "DIC_NAME"
                              value-field = "DIC_CODE"
                              :queryCondition="{'DIC_CATEGORY:0': '回收备件', 'DIC_PCODE:3': '-1' }"
                              :show-null-option = "true"
                              :enable-search="true"
                              name="REPAIR_PART_RECOVERY"
                              v-model="config.form.REPAIR_PART_RECOVERY"
                            ></layui-select>
                        </div>
                      </div>
                      <div class="layui-form-item"  v-if="!showRepairType">
                        <label class="layui-form-label"><span class="x-red">*</span>单价： </label>
                        <div class="layui-input-inline">
                          <input type="text" v-model="config.form.REPAIR_PART_MONEY" autocomplete="off" class="layui-input"  name="REPAIR_PART_MONEY"  placeholder="请输入单价" />
                        </div>
                      </div>
                      <div class="layui-form-item"  v-show="!showRepairType">
                        <label class="layui-form-label">仓库： </label>
                        <div class="layui-input-inline">
                          <layui-multiselect
                            :single="true"
                            :enabled="true"
                            name="REPAIR_PART_STORE"
                            table-name="DB_DICTIONARY"
                            text-field="DIC_NAME"
                            value-field="DIC_CODE"
                            :show-null-option="true"
                            :enable-search="true"
                            :queryCondition="{'DIC_CATEGORY':'仓库', 'JB:5':'2'}"
                            v-model="config.form.REPAIR_PART_STORE"
                          ></layui-multiselect>
                        </div>
                      </div>
                       <div class="layui-form-item"  v-if="!showRepairType">
                        <label class="layui-form-label">备注： </label>
                        <div class="layui-input-inline">
                          <textarea type="textarea" v-model="config.form.REPAIR_PART_REMARK" autocomplete="off" class="layui-textarea"   placeholder="请输入备注" />
                        </div>
                      </div>

                      <div class="layui-form-item" v-show="showRepairType">
                        <label class="layui-form-label"><span class="x-red">*</span>客户名称： </label>
                        <div class="layui-input-inline">
                          <layui-multiselect
                            :single="true"
                            ref="clientSelect"
                            :enabled="true"
                            name="CLIENT_ID"
                            @selectChange="clientChange($event)"
                            table-name="YW_CUSTOMER_CLIENT"
                            text-field="CLIENT_NAME"
                            value-field="CLIENT_ID"
                            :show-null-option="true"
                            :enable-search="true"
                            v-model="config.form.CLIENT_ID"
                          ></layui-multiselect>
                        </div>
                      </div>
                      <div class="layui-form-item" v-if="showRepairType">
                        <label class="layui-form-label"><span class="x-red">*</span>品牌名称： </label>
                        <div class="layui-input-inline">
                          <layui-multiselect
                            :single="true"
                            ref="brandSelect"
                            :enabled="true"
                            name="BRAND_ID"
                            @selectChange="brandChange($event)"
                            table-name="YW_BRAND_DETAIL_V"
                            text-field="BRAND_NAME"
                            value-field="BRAND_ID"
                            :show-null-option="true"
                            :enable-search="true"
                            v-model="config.form.BRAND_ID"
                          ></layui-multiselect>
                        </div>
                      </div>
                      <div class="layui-form-item"  v-show="showRepairType">
                        <label class="layui-form-label">仓库： </label>
                        <div class="layui-input-inline">
                          <layui-multiselect
                            :single="true"
                            :enabled="true"
                            name="REPAIR_PART_STORE"
                            table-name="DB_DICTIONARY"
                            text-field="DIC_NAME"
                            value-field="DIC_CODE"
                            :show-null-option="true"
                            :enable-search="true"
                            :queryCondition="{'DIC_CATEGORY':'仓库', 'JB:5':'2'}"
                            v-model="config.form.REPAIR_PART_STORE"
                          ></layui-multiselect>
                        </div>
                      </div>
                      <!-- <pub-form :config="config" ref="repairPartPubForm" @selectChange="selectChange" @multSelectChange='multSelectChange'/> -->
                    </div>
                  </div>
                </div>
              </layui-collapse>
            </template>
          </div>
          <div class="layui-form-btn">
            <div class="layui-footer">
              <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">
                关 闭
              </button>
              <button class="layui-btn" title="保存" @click="handleBtnclick('save')">
                保 存
              </button>
            </div>
          </div>
        </template>
      </layui-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    formType: {
      type: String,
      default: () => ''
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showRepairType: false,
      requestId: 'repairPartRequest',
      form_rule: {
        REPAIR_PART_TYPE: {
          required: { message: '备件类型不能为空' }
        },
        REPAIR_PART_NAME: {
          required: { message: '备件名称不能为空'},
        },
        REPAIR_PART_MODEL: {
          required: { message: '型号不能为空'},
        },
        REPAIR_PART_SERIAL: {
          required: { message: '序列号不能为空'},
        },
        REPAIR_PART_MONEY: {
          required: { message: '单价不能为空'},
        },
        CLIENT_ID: {
          required: { message: '客户名称不能为空'},
          optional: true
        },
        BRAND_ID: {
          required: { message: '品牌名称不能为空'},
          optional: true
        },
      },
       config: {
        render: [
          { required: true, label: '备件名称',
            children: [
              {type: 'input', name: 'REPAIR_PART_NAME',}
            ]
          },
          { required: true, label: '型号',
            children: [
              {type: 'input', name: 'REPAIR_PART_MODEL',}
            ]
          },
          { required: true, label: '序列号',
            children: [
              {type: 'input', name: 'REPAIR_PART_SERIAL',}
            ]
          },
          //备件类别 临采 备机  REPAIR_PART_CATEGORY    回收备件 可用 作废 REPAIR_PART_RECOVERY
          // { label: '备件类别',
          //   children: [
          //     {type: 'select', name: 'REPAIR_PART_CATEGORY', tableName: 'DB_DICTIONARY', textField: 'DIC_NAME', valueField: 'DIC_CODE',enableSearch: true,queryCondition: {'DIC_CATEGORY:0' : '备件类别', 'DIC_PCODE:3': '-1' }, sort: [],}
          //   ]
          // },
          { label: '回收备件',
            children: [
              {type: 'select', name: 'REPAIR_PART_RECOVERY', tableName: 'DB_DICTIONARY', textField: 'DIC_NAME', valueField: 'DIC_CODE',enableSearch: true,queryCondition: {'DIC_CATEGORY:0' : '回收备件', 'DIC_PCODE:3': '-1' }, sort: [],}
            ]
          },
          { required: true, label: '单价',
            children: [
              {type: 'input', name: 'REPAIR_PART_MONEY',}
            ]
          },
           { required: false, label: '仓库',
            children: [
              {type: 'input', name: 'REPAIR_PART_STORE',}
            ]
          },
          { label: '备注',
            children: [
              {type: 'textarea', name: 'REPAIR_PART_REMARK',}
            ]
          },
        ],
        form: {}
      },
    }
  },
 mounted () {
     // 解决 展开收起后的样式问题
    $('.layui-colla-item').on('click', function () {
      var othis = $(this),
          elemCont = othis.children('.layui-colla-title'),
          elemCont1 = othis.children('.layui-colla-content'),
          isNone = elemCont1.css('display') === 'none';
      if (isNone) {
        elemCont.css('border-radius', '8px');
      } else {
        elemCont.css('border-radius', '8px 8px 0px 0px');
      }
    })
    this.$nextTick(() => {
      if (this.formType === 'edit') {
        this.$refs.repairPartForm.openWin('编辑', this.close_callBack );
        if(this.formData.REPAIR_PART_TYPE == '2'){
          this.showRepairType = true
          this.formRuleValidate()
        }
        this.config.form = this.formData;

      } else {
        this.$refs.repairPartForm.openWin('新增备件',  this.close_callBack );
      }
    })
  },
  methods: {
    /**
     * form弹窗关闭的回调
     */
    close_callBack() {
      this.$emit('update:visible', false)
    },
    /**
     * 下拉框changge事件
     */
    // selectChange(params, sort, field) {
    //   this.config = config_obj
    //   this.form_rule = form_rule_obj
    // },
    multSelectChange(data){
       this.showRepairType = false
      if(data.DIC_CODE == '2') {
        this.showRepairType = true
      }
      this.formRuleValidate()
    },
    // 根据不同的备件类型  进行校验 //校验可选项 optional true不校验 false 校验
    formRuleValidate(){
      if(this.showRepairType) {
        this.form_rule.CLIENT_ID.optional = false
        this.form_rule.BRAND_ID.optional = false
        this.form_rule.REPAIR_PART_MONEY.optional = true
      }
    },
     //客户变化
    clientChange(data){
      if(data.length > 0){
        this.$refs.brandSelect.queryCondition.CLIENT_ID = data[0]._row.CLIENT_ID;
        this.$refs.brandSelect.refreshAsyncData();
      }else{
        this.$refs.brandSelect.queryCondition.CLIENT_ID = "";
        this.$refs.brandSelect.refreshAsyncData();
      }
    },
    //品牌变化
    brandChange(data){
      if(data.length > 0){
        this.config.form["BRAND_NAME_"] =  data[0]._row.BRAND_NAME;
        this.config.form["CLIENT_NAME_"] =  data[0]._row.CLIENT_NAME;
        this.config.form.CLIENT_ID =  data[0]._row.CLIENT_ID;
      } else {
        this.config.form.CLIENT_ID = "";
        this.$refs.brandSelect.queryCondition.CLIENT_ID = "";
        this.$refs.brandSelect.refreshAsyncData();
      }
    },
    /**
     * 保存、重置
     */
    handleBtnclick(type) {
      this.formRuleValidate()
      switch (type) {
        case 'close': {
          this.$emit('update:visible', false)
          break
        }
        case 'save': {
          this.$refs.repairPartForm.editRow = this.config.form
          this.$refs.repairPartForm.save(this.$parent.$refs.repairPartTable)
          break
        }
        default: {
          break
        }
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/workOrder/repairPart/repairPartForm.vue